import { render } from "./CompanyManager.vue?vue&type=template&id=15ade2a0&scoped=true"
import script from "./CompanyManager.vue?vue&type=script&lang=js"
export * from "./CompanyManager.vue?vue&type=script&lang=js"

import "./CompanyManager.vue?vue&type=style&index=0&id=15ade2a0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ade2a0"]])

export default __exports__